import { useState } from 'react'
import styles from './PropertySpyResultItem.module.css'
import { PropertySpyResultCardContainer } from './containers/PropertySpyResultCardContainer'
import { PropertySpySelectorContainer } from './containers/PropertySpySelectorContainer'

interface propertySpyResultItemProps {
}

export const PropertySpyResultItem = (props: propertySpyResultItemProps): JSX.Element => {
    const [propertySpyId, setPropertySpyId] = useState<number | undefined>(undefined)

    const handlePropertySpyChange = (event: any) => {
        setPropertySpyId(event)
    }

    return (
        <div className={styles.PropertySpyResultItem__Root}>
            <PropertySpySelectorContainer
                propertySpyId={propertySpyId}
                onPropertySpyChange={handlePropertySpyChange}
            />
            <br/>
            <PropertySpyResultCardContainer
                propertySpyId={propertySpyId}
            />
        </div>
    )
}